import { useEffect, useState } from 'react';

type Properties = {
  bodyReference: React.RefObject<HTMLDivElement | null>;
};

export const useScrollbarWidth = ({ bodyReference }: Properties) => {
  const [scrollbarWidth, setScrollbarWidth] = useState(0);

  useEffect(() => {
    const element = bodyReference.current;

    if (!element) {
      return;
    }

    const updateScrollbarWidth = () => {
      setScrollbarWidth(element.offsetWidth - element.clientWidth);
    };

    updateScrollbarWidth();

    const resizeObserver = new ResizeObserver(updateScrollbarWidth);
    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, [bodyReference]);

  return scrollbarWidth;
};
